<template>
<v-flex class="neg-margin pt-5 text-xs-center" xs12>
  <div v-if="loading" class="py-5 text-xs-center"><div class="my-5 py-5">
    <v-progress-circular color="secondary" indeterminate></v-progress-circular>
  </div></div>
  <v-layout v-else row justify-center>
    <v-flex class="py-4 px-2" xs12 md10 lg9>
      <v-btn to="https://www.rophemnursing.com/nclex-prep" color="secondary">Course Info</v-btn>
      <v-btn to="https://forms.gle/n34i6ZPnDvuWuzTD9" color="secondary">Remedial Book</v-btn>
      <v-btn to="https://docs.google.com/forms/d/e/1FAIpQLScA5asU-gLXydhK968z0FL8TJIonXbUOSDx9gn2kpdHy4Olfw/viewform" color="secondary">Remedial Form</v-btn>
      <v-tabs class="pa-0 mx-0 mb-0 mt-2" v-model="subjectTab" color="transparent" slider-color="secondary" centered>
        <v-tab class="spaced" v-for="(sub, i) in allSubjects" :key="i" ripple><b>{{sub}}</b></v-tab>
        <v-tab-item v-for="(sub, i) in allSubjects" :key="i">
          <v-layout row wrap justify-center>
            <v-flex v-if="!publishedExists(sub)" class="py-5 text-xs-center" xs12>
              <div class="display-2 secondary--text pb-3">No {{sub}} Courses</div>
              <div class="display-2 secondary--text">Check back soon!</div>
            </v-flex>
            <v-flex v-else xs12 md11>
              <v-layout row wrap justify-center>
                <v-flex class="pa-3" v-for="(c, i) in courses" v-if="c[0].subject == sub" :key="i" xs12 sm6>
                  <r-course-card :now="now" :courses="c"></r-course-card>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-tab-item>
      </v-tabs>
    </v-flex>
  </v-layout>

  <r-register-popup :popup="popup" :course-data="courseData" :payment-id="paymentId"></r-register-popup>
</v-flex>
</template>

<script>
import RegisterPopup from './RegisterPopup.vue'
import CourseCard from './CourseCard.vue'
import {coursesEvent} from '../../../main'
export default {
  components: {
    rRegisterPopup: RegisterPopup,
    rCourseCard: CourseCard
  },
  data: () => ({
    loading: false,
    subjectTab: null,
    allSubjects: ['RN', 'PN'],
    courseData: {},
    stripeHandler: null,
    paymentId: null,
    popup: {
      show: false,
      type: ''
    }
  }),
  computed: {
    now () {
      return this.$store.getters.now
    },
    user () {
      return this.$store.getters.user
    },
    allCourses () {
      return this.$store.getters.courses
    },
    publishedExists () {
      return (subject) => {
        for (let course of this.allCourses) {
          if (course.subject === subject && course.published) return true
        }
        return false
      }
    },
    courses () {
      const grouped = []
      let added = false
      for (let course of this.allCourses) {
        if (course.published) {
          for (let group of grouped) {
            if (group[0].name === course.name) {
              group.push(course)
              added = true
              group.sort((a, b) => {
                return parseInt(a.onlineDays, 10) - parseInt(b.onlineDays, 10)
              })
            }
          }
          if (!added) grouped.push([course])
          added = false
        }
      }
      grouped.sort((a, b) => {
        if (!a[0].dates && !b[0].dates) return a[0].name.localeCompare(b[0].name, undefined, {numeric: true, sensitivity: 'base'})
        else if (!a[0].dates) return 1
        else if (!b[0].dates) return -1
        else return (new Date(a[0].dates[0])).valueOf() - (new Date(b[0].dates[0])).valueOf()
      })
      return grouped
    }
  },
  beforeMount () {
    coursesEvent.$off()
    this.load()
    coursesEvent.$on('registerPopup', key => {
      this.registerPopup(key)
    })
    coursesEvent.$on('canRegister', () => {
      this.canRegister()
    })
  },
  beforeDestroy () {
    if (this.stripeHandler) {
      this.stripeHandler.close()
      this.stripeHandler = null
    }
  },
  methods: {
    load () {
      this.loading = true
      this.initStripe()
      if (this.$store.getters.coursesModuleLoaded) this.loading = false
      else {
        this.$store.dispatch('loadCourses').then(() => {
          this.loading = false
        })
      }
    },
    initStripe () {
      if (this.user) {
        if (!this.stripeHandler) {
          this.stripeHandler = window.StripeCheckout.configure({
            // key: 'pk_test_geD37HCkE8ySbfE3XtmnUg3t',
            key: 'pk_live_fpuUBwtcYSOS2opPTIIJAQ3o',
            email: this.user.email,
            zipCode: true,
            allowRememberMe: false,
            token: token => {
              this.processPayment(token)
            }
          })
        }
      }
    },
    requestPayment () {
      let course = this.$store.getters.courseByKey(this.$store.getters.courseToRegister)
      this.stripeHandler.open({
        name: 'Rophem Nursing Academy',
        description: course.name + ', ' + course.onlineDays + ' days online',
        amount: parseInt(course.price) * 100
      })
    },
    processPayment (token) {
      let course = this.$store.getters.courseByKey(this.$store.getters.courseToRegister)
      let newPayment = {
        courseKey: course.key,
        studentId: this.user.uid,
        amount: parseInt(course.price) * 100,
        description: course.name + ', ' + course.onlineDays + ' days online',
        date: this.now,
        token: token
      }
      this.popup = {
        show: true,
        type: 'Registering'
      }
      this.$store.dispatch('addPayment', newPayment).then(paymentId => {
        this.paymentId = paymentId
      })
    },
    registerPopup (key) {
      this.courseData = this.$store.getters.courseByKey(key)
      this.popup.show = true
      this.popup.type = 'Register'
    },
    canRegister () {
      this.$store.dispatch('setCourseToRegister', this.courseData.key)
      if (this.user) {
        this.requestPayment()
      } else {
        const appMsg = {
          type: 'error',
          msg: 'Please sign in to register!'
        }
        this.$store.dispatch('showAppMsg', appMsg)
      }
    },
    register () {
      let newProgress = {
        name: this.courseData.name,
        url: '',
        courseKey: this.courseData.key,
        studentId: this.user.uid,
        endTime: 0
      }
      let newCourse = {
        ...this.courseData,
        students: this.courseData.students ? [...this.courseData.students] : []
      }
      this.$store.dispatch('createProgress', newProgress).then(() => {
        if (this.user.type.toLowerCase() === 'student') newCourse.students.push(this.user.uid)
        this.$store.dispatch('updateCourse', newCourse).then(() => {
          let appMsg = {
            type: 'success',
            msg: 'Registerd for ' + newCourse.name
          }
          this.$store.dispatch('showAppMsg', appMsg)
          this.$router.push('/my-courses')
        })
      })
    },
    open (courseData) {
      let liveOpen = false
      if (courseData.type === 'Live') {
        liveOpen = courseData.type === 'Live' && courseData.maxStudents > this.studentCount
        liveOpen = liveOpen && this.now < new Date(courseData.dates[0]).valueOf()
        return liveOpen
      } else return true
    },
    studentCount (courseData) {
      let count = 0
      if (courseData.type === 'Live') {
        for (let course of this.$store.getters.courses) {
          if (course.type === 'Live') {
            if (course.startTime === courseData.startTime) {
              if (this.$store.getters.arrayEquals(courseData.dates, course.dates) && course.students) count += course.students.length
            }
          }
        }
      } else {
        let group = []
        for (let g of this.courses) {
          if (g[0].name === courseData.name) group = g
        }
        for (let course of group) {
          if (course.students) count += course.students.length
        }
      }
      return count
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/site/courses/Register.vue